import React from "react";
import { journey, screen } from "../../../../../images/index.js";

const OurJourney = () => {
  return (
    <div className="our-journey ">
      {/* Top Section */}
      <h6 className="about-sub-heading mb-2 text-center">Who We Serve</h6>
      {/* Bottom Section */}
      <div className="row g-5 team-journey-card">
        <div className="col-sm-6 col-md-6 col-lg-3">
          <div className="journey-box h-100 shadow-sm overflow-hidden p-4">
            <div className="d-flex justify-content-center">
            <img src={screen} className="img-fluid" alt="screen" />
            </div>
          <div className="journey-box-content">
              <h6 className="hero-sub-text"> Owners & Brand Founders</h6>
              <p className="about-sub-content">
                See your Amazon business health instantly after the payment
                schedule{" "}
              </p>
            </div>
          </div>
        </div>

        <div className="col-sm-6 col-md-6 col-lg-3">
          <div className="journey-box h-100 p-4 shadow-sm">
            <div className="d-flex justify-content-center">
              <img src={screen} className="img-fluid" alt="screen" />
            </div>
            <div className="journey-box-content">
              <h6 className="hero-sub-text"> Agencies</h6>
              <p className="about-sub-content">
                Manage multiple brands with clarity & confidence value (insights).{" "}
              </p>
            </div>
          </div>
        </div>

        <div className="col-sm-6 col-md-6 col-lg-3">
          <div className="journey-box h-100 p-4 shadow-sm">
            <div className="d-flex justify-content-center">
              <img src={screen} className="img-fluid" alt="screen" />
            </div>
            <div className="journey-box-content">
              <h6 className="hero-sub-text"> Managers & Executives</h6>
              <p className="about-sub-content">
                Take smarter decisions without manually digging into{" "}
              </p>
            </div>
          </div>
        </div>

        <div className="col-sm-6 col-md-6 col-lg-3">
          <div className="journey-box h-100 p-4 shadow-sm">
              <div className="d-flex justify-content-center">
              <img src={screen} className="img-fluid" alt="screen" />
            </div>
            <div className="journey-box-content">
              <h6 className="hero-sub-text">Resellers & Distributors</h6>
              <p className="about-sub-content">
                Understand what sells, where, how, and when{" "}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OurJourney;
